import React, { useState } from 'react';
import Icon from '../AppIcon';
import { useCart } from './CartContext';
import { getPrimaryImage } from '../../utils/imageUtils';

const CartItemCard = ({ item }) => {
  const { increaseQty, decreaseQty } = useCart();
  const [imgError, setImgError] = useState(false);
  const lineTotal = (item.price * item.quantity).toFixed(2);

  return (
    <div className="flex items-center gap-3 py-3.5">
      {/* Thumbnail */}
      <div className="w-14 h-14 rounded-xl overflow-hidden bg-muted flex-shrink-0 border border-border">
        {getPrimaryImage(item.imageUrl) && !imgError ? (
          <img
            src={getPrimaryImage(item.imageUrl)}
            alt={item.name}
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10">
            <Icon name={item.type === 'product' ? 'Package' : 'Sparkles'} size={20} className="text-primary/60" />
          </div>
        )}
      </div>

      {/* Name + unit price */}
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm text-foreground truncate">{item.name}</p>
        <p className="text-xs text-muted-foreground mt-0.5">GH¢{item.price.toFixed(2)} each</p>
      </div>

      {/* Line total + qty controls */}
      <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
        <span className="text-sm font-bold text-foreground">GH¢{lineTotal}</span>
        <div className="flex items-center gap-1">
          <button
            onClick={() => decreaseQty(item.id)}
            className={`w-8 h-8 rounded-full border flex items-center justify-center transition-colors ${
              item.quantity === 1
                ? 'border-destructive/40 text-destructive hover:bg-destructive/10'
                : 'border-border text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon name={item.quantity === 1 ? 'Trash2' : 'Minus'} size={13} />
          </button>
          <span className="w-6 text-center text-sm font-bold text-foreground">{item.quantity}</span>
          <button
            onClick={() => increaseQty(item.id)}
            className="w-8 h-8 rounded-full border border-border text-muted-foreground hover:bg-primary/10 hover:border-primary/40 hover:text-primary flex items-center justify-center transition-colors"
          >
            <Icon name="Plus" size={13} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartItemCard;
